module.exports = __webpack_public_path__ + "static/img/red2.8395358.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/red2.png
// module id = 9tVK
// module chunks = 1